<template>
  <users />
</template>

<script>
import Users from "@/components/3pl/Users/index";
export default {
  components: {
    Users,
  },
};
</script>

<style></style>
